import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Icon } from '@node-space/ui-components'
import { CardTransactionExportModal } from './CardTransactionExportModal'

interface CardTransactionExportProps {
  cardId?: string
}

export const CardTransactionExport = ({ cardId }: CardTransactionExportProps) => {
  const { t } = useTranslation()

  const [showCustomDateExportModal, setShowCustomDateExportModal] = useState(false)

  const handleClose = () => {
    setShowCustomDateExportModal(false)
  }

  return (
    <>
      {showCustomDateExportModal && (
        <CardTransactionExportModal handleClose={handleClose} cardId={cardId} />
      )}
      <Button
        variant="secondary"
        iconElement={<Icon name="DownloadSimple" />}
        onClick={() => setShowCustomDateExportModal(true)}
        testId="export-card-transactions-btn"
      >
        {t('export')}
      </Button>
    </>
  )
}
